import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useFetchExecutionSubGroupById from "../../hooks/useFetchExecutionSubGroupById";
import { useBreadCrumbContext } from "../../contexts/BreadCrumbContext";
import { IconBtnEditBase } from "../../common/utils/icons";
import Loader from "../../components/Molecules/Loader/Loader";

const ViewExecutionSubGroup: React.FC = () => {
  const { setCurrentBreadcrumbPage } = useBreadCrumbContext();
  const { id: executionSubGroupId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // hooks
  const [executionSubGroupData] = useFetchExecutionSubGroupById({
    setIsLoading,
    currentExecutionSubGroupId: executionSubGroupId,
  });
  useEffect(() => {
    setCurrentBreadcrumbPage({
      name: executionSubGroupData?.name,
      id: executionSubGroupData?.id,
    });
    return () => {
      setCurrentBreadcrumbPage({ name: "", id: null });
    };
  }, [executionSubGroupData]);

  return (
    <Box>
      {isLoading && <Loader isLoading={isLoading} />}
      <Box className="text-box-card compact-text-box-card">
        <Grid container rowSpacing={1.5} columnSpacing={2.5}>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">Name</label>
            <div className="form-control">
              {executionSubGroupData?.name || "N/A"}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <label className="label-text text-bold">Code</label>
            <div className="form-control">
              {executionSubGroupData?.code || "N/A"}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            {executionSubGroupData?.description && (
              <>
                <label className="label-text text-bold">Description</label>
                <div className="form-control break-word">
                  {executionSubGroupData?.description || "N/A"}
                </div>
              </>
            )}
          </Grid>
          <Grid item xs sx={{ justifyContent: "flex-end", display: "flex" }}>
            <label className="label-text text-bold">&nbsp;</label>
            <button
              className="btn-nostyle icon-btn-edit"
              onClick={() =>
                navigate(`/execution-sub-group/edit/${executionSubGroupId}`)
              }
            >
              <IconBtnEditBase ariaLabel="Edit execution sub group" />
            </button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ViewExecutionSubGroup;
